import Variation from './Variation';

class Round {
  public competitionDecided: boolean;
  public cvPerDay: number;
  public id: string;
  public num: number;
  public pvPerDay: number;
  public score: string;
  public state: string;
  public startedAt: Date;
  public endedAt: Date;
  public willStartAt: Date;
  public willEndAt: Date;
  public targetImprovementRate: number;
  public variations: any[];

  constructor({
    competition_decided,
    cv_per_day,
    id,
    num,
    pv_per_day,
    score,
    state,
    started_at,
    ended_at,
    will_start_at,
    will_end_at,
    target_improvement_rate,
    variations,
  }: {
    competition_decided: boolean;
    cv_per_day: number;
    id: string;
    num: number;
    pv_per_day: number;
    score: string;
    state: string;
    started_at: Date;
    ended_at: Date;
    will_start_at: Date;
    will_end_at: Date;
    target_improvement_rate: number;
    variations: any[];
  }) {
    this.competitionDecided = competition_decided;
    this.cvPerDay = cv_per_day;
    this.id = id;
    this.num = num;
    this.pvPerDay = pv_per_day;
    this.score = score;
    this.state = state;
    this.startedAt = started_at;
    this.endedAt = ended_at;
    this.willStartAt = will_start_at;
    this.willEndAt = will_end_at;
    this.targetImprovementRate = target_improvement_rate;
    this.variations = variations.map(variation => new Variation(variation));
  }
}

export default Round;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/entity/Round.ts